import React from 'react';
import * as styles from './styles.scss';

const Loader = ({ isLoading, children }) => (
    <div
        { ...(isLoading ? { className: styles.loader} : {}) }
    >
        {children}
        {
            isLoading &&
            <div className={styles.container}>
                <div className={styles.indicator}>
                    <span/>
                    <span/>
                    <span/>
                    <span/>
                    <span/>
                </div>
            </div>
        }
        {isLoading && <div className={styles.hover} />}
    </div>
);


export default Loader;
